import { useMutation } from 'react-query';
import { createLazyRestRequest } from 'utils/hooks/api';
import { DELETE_LIST_ENDPOINT } from 'api/ManageListsAPI';
import { isUndefined } from 'utils/tsHelpers';
import { ApiResponse } from 'services/api';

import { createEmailListIdParams } from '../utils';
import { List } from '../types';

export const useLazyDeleteListMutation = () => {
  const { mutateAsync, ...rest } = useMutation(
    createLazyRestRequest({ url: DELETE_LIST_ENDPOINT }),
  );
  const deleteListAsync = (vars: { list: Partial<List> }): Promise<ApiResponse> => {
    const url = createEmailListIdParams(vars.list, DELETE_LIST_ENDPOINT);
    if (isUndefined(vars?.list?.id)) {
      return mutateAsync({});
    }

    return mutateAsync({
      requestConfig: { url },
    });
  };
  return {
    ...rest,
    deleteListAsync,
  };
};
